<template>
  <div
    :class="`formulate-input-element formulate-input-element--value-help-v2 ${hasRequiredError}`"
    data-type="value-help-v2"
    @click="handleOpenModal"
  >
    <div
      class="mc-input d-inline-flex align-items-center lite"
      :class="{
        'input-md': size == 'md',
        'input-sm': size == 'sm',
        __disabled: disabled,
        __multiple: hasSelected,
      }"
    >
      <!-- This input field is only used to show placeholder using regular input style -->
      <!-- If no value is selected -->
      <input
        v-if="!hasSelected"
        :placeholder="attrs.placeholder || attrs.label"
        class="w-100"
        style="border: 0"
        readonly
      />
      <div v-else-if="localFullObject?.[displayedBy]">
        {{ localFullObject[displayedBy] }}
      </div>
      <div v-else> - </div>

      <i class="icon-fill_menu" />
    </div>

    <ModalOrder @submit="updateItem" />
  </div>
</template>

<script>
import ModalOrder from '../ModalOrder'
import isEmpty from 'lodash/isEmpty'

export default {
  components: {
    ModalOrder,
  },
  props: {
    size: {
      type: String,
      default: 'md',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    multiple: {
      type: Boolean,
      default: false,
    },

    displayedBy: {
      type: String,
    },

    fullObject: {},
  },
  emits: ['update:fullObject'],
  data() {
    return {
      localFullObject: {},
    }
  },
  computed: {
    attrs() {
      return this.$attrs
    },
    slotFields() {
      return this.attrs?.tableFields ? this.attrs.tableFields.filter((v) => v.isSlot) : []
    },

    // add classes if it has validation error
    hasRequiredError() {
      // TODO will be continue for next development
      // if (this.context.visibleValidationErrors.includes('Wajib diisi'))
      //   return 'formulate-input-error__required'
      return ''
    },

    // if there is selected value(s)
    hasSelected() {
      return this.displayedBy in this.localFullObject && this.localFullObject[this.displayedBy] !== '' /** localFullObject: For DO accurate needs */
    },
  },
  watch: {
    fullObject: {
      handler(val) {
        this.localFullObject = this.multiple ? [ ...val ] : { ...val }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    isEmpty,
    handleOpenModal() {
      if (this.disabled) return
      this.$bvModal.show('mc-modal-order')
    },
    updateItem(item) {
      this.localFullObject = this.multiple ? item : item[0]
      this.$emit('updateOrderValue', this.localFullObject)
      this.$emit('update:fullObject', this.multiple ? item : item[0])
    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
